// extracted by mini-css-extract-plugin
export var container = "_hc-1";
export var editor = "_hc-2";
export var resizable = "_hc-3";
export var wrapper = "_hc-0";